import { render, staticRenderFns } from "./HeaderDashboard.vue?vue&type=template&id=1857642c"
import script from "./HeaderDashboard.vue?vue&type=script&lang=js"
export * from "./HeaderDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../.yarn/__virtual__/vue-loader-virtual-7370889e7c/0/cache/vue-loader-npm-15.11.1-829412283a-509a816d45.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Logo: require('/builds/onbeams/web/src/components/global/Logo.vue').default,NetworkImage: require('/builds/onbeams/web/src/components/global/NetworkImage.vue').default,Header: require('/builds/onbeams/web/src/components/Header.vue').default})
